export default __webpack_public_path__ + "static/centerVideo-a46014522f707376d9ef8764905d378b.mp4";